import './error-page.scss';

function ErrorPage() {
  return (
    <div>
      <h1>Oops!</h1>
      <p>
        Sorry, an unexpected error has occurred. This page could not be found!
      </p>
    </div>
  );
}

export default ErrorPage;
